module.exports = __webpack_public_path__ + "a8a5485c6d0565f36b880fce3cb82ae5.fbx";